import React from 'react'
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";

function DeleteSecretData (props) {
          return(
                    <div>
                            <div style={{fontSize:"20px",fontWeight:"normal"}}>{props.name.length > 40 ? <EllipsisWithTooltip placement="bottom">
                               {props.name} ?</EllipsisWithTooltip>:<div style={{textAlign:"center"}}>{props.name} ?</div>}
                            </div>
                            <div className="text">
                                    <button className="btn"  onClick={()=>props.toggle()}>
                                                No
                                    </button>
                                    <button className="danger-button" onClick={()=>props.deleteSecret()}>
                                                Yes
                                    </button>
                            </div>
                    </div>
          )
}
export default DeleteSecretData